<p-sidebar
  [(visible)]="visible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-profile-sidebar w-full sm:w-28rem"
>
  <div
    class="layout-rightmenu h-full overflow-y-auto overflow-x-hidden"
    [ngClass]="{
      'layout-rightmenu-active': layoutService.state.rightMenuActive
    }"
  >
    <p-megaMenu
      [model]="organizationsMenuItems"
      class="layout-rightmenu-organization"
      [ngClass]="layoutService.config().colorScheme === 'dark' ? 'themeDark' : 'themeLight'"
    ></p-megaMenu>
    <div class="user-detail-wrapper text-center" style="padding: 4.5rem 0 2rem 0">
      <div class="user-detail-content mb-4">
        <p-avatar
          [image]="profilePicture ? profilePicture : 'assets/images/avatars/avatar.png'"
          styleClass="mr-2"
          shape="circle"
          size="xlarge"
          pBadge
          value="4"
          severity="danger"
        ></p-avatar>
        <span class="user-name text-2xl text-center block mt-4 mb-1">{{ user?.fullname }}</span>
        <span class="user-number">{{ (user?.authItems)![0].value }}</span>
        <div class="user-tasks flex justify-content-center mt-5">
          <p-button label="Profile Details" styleClass="p-button-sm" routerLink="/app/user/profile" icon="pi pi-user"></p-button>
        </div>
      </div>
      <div class="user-tasks flex justify-content-between align-items-center py-4 px-3 border-bottom-1 surface-border">
        <p-tabView class="w-full">
          <p-tabPanel header="Notifications">
            <app-notification-list [panelView]="true" />
          </p-tabPanel>
          <p-tabPanel header="Invites">
            <div *ngIf="invites?.length === 0">You do not have any invites</div>

            <div class="daily-plan-wrapper mt-0" *ngIf="invites.length > 0">
              <span class="text-xl">Pending Invites</span>
              <ul>
                <li *ngFor="let invite of invites">
                  <span class="event-topic">{{ invite?.organization?.name }}</span>
                  <span class="event-time">Invite by {{ invite?.invitedBy?.firstname }}</span>
                  <span class="text-right">
                    <button
                      pButton
                      icon="pi pi-check"
                      label="Accept"
                      (click)="acceptInvite(invite)"
                      class="p-button-primary p-button-sm mr-2 p-1"
                    ></button>

                    <button pButton icon="pi pi-times" label="Reject" (click)="rejectInvite(invite)" class="p-button p-button-sm p-1"></button>
                  </span>
                </li>
              </ul>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</p-sidebar>
